'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/* injects from baggage-loader */

/* eslint no-console: 0 */

exports.getUser = getUser;
exports.getProjects = getProjects;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _reduxSaga = require('redux-saga');

var _kebakaran = require('kebakaran');

var _firebase = require('../utils/firebase');

var _firebase2 = _interopRequireDefault(_firebase);

var _userActions = require('../actions/userActions');

var _projectsActions = require('../actions/projectsActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getUser, getProjects].map(regeneratorRuntime.mark);

var debug = require('debug')('metapro:sagas:user');

function getUser(userId) {
  var userStream, user;
  return regeneratorRuntime.wrap(function getUser$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          debug('start getUser(%s)', userId);

          userStream = (0, _kebakaran.stream)((0, _firebase2.default)('users/' + userId));
          _context.prev = 2;

        case 3:
          if (!true) {
            _context.next = 12;
            break;
          }

          _context.next = 6;
          return userStream.next();

        case 6:
          user = _context.sent;

          if (user !== null) {
            user = _extends({}, user, { id: userId });
          }
          _context.next = 10;
          return (0, _reduxSaga.put)((0, _userActions.setShownUser)(user));

        case 10:
          _context.next = 3;
          break;

        case 12:
          _context.next = 17;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](2);

          if (!(_context.t0 instanceof _reduxSaga.SagaCancellationException)) {
            console.warn('unknown Error', _context.t0);
          }

        case 17:
          _context.prev = 17;

          userStream.close();
          return _context.finish(17);

        case 20:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[2, 14, 17, 20]]);
}

function getProjects(userId, mode) {
  var listRef, mapKey, projectsStream, projects;
  return regeneratorRuntime.wrap(function getProjects$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          (0, _invariant2.default)(userId, 'getProjects requires userId');
          (0, _invariant2.default)(mode === 'permissions' || mode === 'public', 'getProjects requires mode to be `permission` or `public`');

          listRef = mode === 'permissions' ? (0, _firebase2.default)('userPermissions').orderByChild('user').equalTo(userId) : (0, _firebase2.default)('users/' + userId + '/publicProjects');
          mapKey = mode === 'permissions' ? function (perm) {
            return perm.val().project;
          } : function (proj) {
            return proj.key;
          };
          projectsStream = (0, _kebakaran.stream)((0, _kebakaran.list)(listRef, function (key) {
            return (0, _kebakaran.struct)({
              name: (0, _firebase2.default)('projects/' + key + '/name'),
              owner: (0, _firebase2.default)('projects/' + key + '/owner'),
              nodes: (0, _firebase2.default)('projects/' + key + '/graph/nodes'),
              public: (0, _firebase2.default)('projects/' + key + '/public')
            });
          }, { mapKey: mapKey }));
          _context2.prev = 5;
          _context2.next = 8;
          return (0, _reduxSaga.put)((0, _projectsActions.setProjectsList)([]));

        case 8:
          if (!true) {
            _context2.next = 16;
            break;
          }

          _context2.next = 11;
          return projectsStream.next();

        case 11:
          projects = _context2.sent;
          _context2.next = 14;
          return (0, _reduxSaga.put)((0, _projectsActions.setProjectsList)(projects || []));

        case 14:
          _context2.next = 8;
          break;

        case 16:
          _context2.next = 21;
          break;

        case 18:
          _context2.prev = 18;
          _context2.t0 = _context2['catch'](5);

          if (!(_context2.t0 instanceof _reduxSaga.SagaCancellationException)) {
            console.warn('unknown Error', _context2.t0);
          }

        case 21:
          _context2.prev = 21;

          projectsStream.close();
          return _context2.finish(21);

        case 24:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[5, 18, 21, 24]]);
}


//////////////////
// WEBPACK FOOTER
// ./app/sagas/user.js
// module id = 638
// module chunks = 1